/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DeleteDialogComponent } from '@ng-falcon/dialog/delete-dialog/delete-dialog.component';
import { DialogTitleComponent } from '@ng-falcon/dialog/dialog-title/dialog-title.component';
import { NgfButtonDirective } from '@ng-falcon/button/ngf-button/ngf-button.directive';
import { MessageModule } from '../messages/message/message.module';
import { ConfirmCancelModalComponent } from './confirmation-modal/confirm-cancel-modal.component';
import { DetailDialogComponent } from './detail-dialog/detail-dialog.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { ModalPageNumberContainerComponent } from './modal-page-number-container/modal-page-number-container.component';
import {
  DefaultOkCancelDialogContentComponent
} from './ok-cancel-dialog/default-ok-cancel-dialog-content/default-ok-cancel-dialog-content.component';
import { OkCancelDialogComponent } from './ok-cancel-dialog/ok-cancel-dialog.component';
import { DefaultOkDialogContentComponent } from './ok-dialog/default-ok-dialog-content/default-ok-dialog-content.component';
import { OkDialogComponent } from './ok-dialog/ok-dialog.component';
import { ReloadAppDialogComponent } from './reload-app-dialog/reload-app-dialog.component';
import {ImpersonationModalComponent} from "@ng-falcon/dialog/impersonation-modal/impersonation-modal.component";
import {FormFieldModule} from "../+legacy/form/form-field/form-field.module";
import {SelectModule} from "@ng-falcon/controls/select/select.module";
import {InputContainerModule} from "@ng-falcon/controls/input-container/input-container.module";
import {TextareaModule} from "@ng-falcon/controls/textarea/textarea.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgfTooltipDirective} from "@ng-falcon/ngf-tooltip/ngf-tooltip.directive";
import { NgfButtonGroupDirective } from '@ng-falcon/button/ngf-button/ngf-button-group.directive';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MessageModule,
    NgfButtonDirective,
    DialogTitleComponent,
    FormFieldModule,
    SelectModule,
    InputContainerModule,
    TextareaModule,
    FormsModule,
    ReactiveFormsModule,
    NgfTooltipDirective,
    NgfButtonGroupDirective
  ],
  declarations: [
    ConfirmCancelModalComponent,
    ErrorModalComponent,
    OkDialogComponent,
    DetailDialogComponent,
    DefaultOkDialogContentComponent,
    OkCancelDialogComponent,
    DefaultOkCancelDialogContentComponent,
    ModalPageNumberContainerComponent,
    ReloadAppDialogComponent,
    DeleteDialogComponent,
    ImpersonationModalComponent,
  ],
  exports: [
    MatDialogModule,
    DialogTitleComponent,
    ConfirmCancelModalComponent,
    ErrorModalComponent,
    OkDialogComponent,
    DetailDialogComponent,
    OkCancelDialogComponent,
    ModalPageNumberContainerComponent,
    DefaultOkCancelDialogContentComponent,
    ImpersonationModalComponent
  ],
})
export class DialogModule {}
